import React from "react";
import { useTranslation } from "react-i18next";
import { useHits } from "react-instantsearch-hooks-web";

/**
 * Empty-state component.
 *
 * By default, it checks the InstantSearch hits to see if the result set is empty.
 * If you pass `isEmpty` (boolean), that override is used instead — handy when the
 * parent applies additional filtering (e.g., favorites-only).
 */
export default function NoFavorites({
  message = "You haven’t favorited anything yet.",
  isEmpty, // optional override from parent (post-filter emptiness)
}) {
  const { t } = useTranslation();
  const ctx = useHits();
  const hits = Array.isArray(ctx?.hits) ? ctx.hits : [];

  const empty =
    typeof isEmpty === "boolean"
      ? isEmpty
      : hits.length === 0;

  if (!empty) return null;

  return (
    <div className="mt-8 rounded-xl border border-white/10 bg-slate-800/40 p-6 text-center">
      <div className="text-lg font-semibold text-slate-200">{t('converters.noFavorites')}</div>
      <p className="mt-1 text-sm text-slate-400">{message || t('converters.noFavoritesYetMessage')}</p>
    </div>
  );
}
